(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-mw-featured"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.accio-mw-featured').forEach(function (section) {
    var tabs = section.querySelectorAll('.accio-mw-featured__tab');
    var panels = section.querySelectorAll('.accio-mw-featured__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.remove('accio-mw-featured__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('accio-mw-featured__panel--active');
        });
        tab.classList.add('accio-mw-featured__tab--active');
        tab.setAttribute('aria-selected', 'true');
        var panel = section.querySelector('#accio-tab-panel-' + target + '-' + section.id.replace('accio-mw-featured-', ''));
        if (panel) panel.classList.add('accio-mw-featured__panel--active');
      });
    });

    section.querySelectorAll('.accio-mw-featured__quick-add:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-product-id');
        if (!variantId) return;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function () {
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 1800);
        }).catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
